import React from 'react'
import {CI2} from '../../utils/calendar'
import ClientElement from '../credit/rowelements/clientelement'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {Loader} from '../../utils/misc'
import moment from 'moment'
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import _ from 'lodash'

export default class Receipt extends React.Component {


  constructor(props){
    super(props)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.submit = this.submit.bind(this)
    this.getReceipt = this.getReceipt.bind(this)
    this.getClientInvoices = this.getClientInvoices.bind(this)
    this.handleClientChange = this.handleClientChange.bind(this)
    this.handleInvoiceChange = this.handleInvoiceChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.deleteReceipt = this.deleteReceipt.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.state = {loading:true, invoiceOptions:[], loadingInvoices:false, client_total_due: 0,
      receipt: {amount:"", date:moment(new Date()).format(), mode:"cash", reference:"", notes:"", is_receipt:true}}
  }


  handleDateChange(da) {
    this.modifyItemState('date', da)
  }
  handleInputChange(e) {
    this.modifyItemState(e.target.name, e.target.value)
  }
  handleClientChange(client) {
    this.setState({loadingInvoices:true,
      invoiceOptions:[],
      receipt:{amount:"", date:moment(new Date()).format(), mode:"cash", reference:"", notes:"",is_receipt:true}
    })
    this.modifyItemState('client', client)
    this.modifyItemState('invoice', null)
    if(client && client.id) {
      this.getClientInvoices(client.id).then((response)=>{
        if(response.status===200) {
          let invoices = response.data.invoices
          let receipts = response.data.receipts
          let totalInvoices = _.sum(_.map( invoices, invoice=> {

                return parseFloat(invoice.total)

          }))
          let totalReceipts = _.sum(_.map(receipts, receipt=>{
             return parseFloat(receipt.amount)
          }))
          let totalDue = parseFloat(totalInvoices-totalReceipts).toFixed(2)

          this.setState({client_total_due: totalDue, client_total_invoices:totalInvoices, client_total_receipts:totalReceipts})
          this.modifyItemState('amount', totalDue)
          this.setState({invoiceOptions: response.data.invoices, loadingInvoices:false})

        }
      }).catch((err)=>{
        this.setState({loadingInvoices:false})
      })
    }
  }
  handleInvoiceChange(invoice) {
      let due = this.getInvoiceDue(invoice)
      this.modifyItemState('amount', due)
    this.modifyItemState('invoice', invoice)
  }


  modifyItemState(key, value) {
    this.setState({errors: undefined})
          let currentRetn = this.state.receipt
          currentRetn[key] = value
          this.setState({
            receipt:currentRetn
         });
  }


  componentDidMount() {

    let params = this.props.match.params
    if(typeof params.receipt_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Receipt " + this.props.match.params.receipt_id
      this.getReceipt(this.props.match.params.receipt_id).then((response)=>{
        if(response.status===200) {
          console.log(response.data.receipt);
          this.setState({receipt: response.data.receipt, loading:false})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
        document.title = "Add Receipt "
        this.setState({loading:false})
    }

  }

  getReceipt(receipt_id) {
    return axios({
      url: '/get_receipt/?id='+receipt_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  getClientInvoices(client_id) {
    return axios({
      url: '/list_invoices/?require_receipts=true&client_id='+client_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  deleteReceipt() {

    axios({
      url: '/delete_receipt/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.receipt
    }).then((response)=> {
      if(response.status === 200) {
          NotificationManager.success("Deleted Receipt successfully")
        setTimeout(()=>{
          this.props.history.push("/receipts/")
        }, 700)
      }
    }).catch((err)=> {
      console.log(err);
    })
  }


    submit(e) {
      this.setState({'submitting':true})

      let apiurl
      if(this.state.mode ==="edit") {
        apiurl  = "/update_receipt/"
      }
      else {
        apiurl  = "/create_new_receipt/"
      }

      axios({
        url: apiurl,
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.receipt
      }).then((response)=> {
        this.setState({'submitting':false})
        if(response.status === 200) {
          if(this.state.mode === "edit") {
              NotificationManager.success("Updated Receipt successfully")
          }
          else {
            NotificationManager.success("Created Receipt successfully")
          }

          setTimeout(()=>{
            this.props.history.push("/receipts/")
          }, 700)

        }
      }).catch((err)=> {
        this.setState({'submitting':false})
        if(typeof err.response !== "undefined" && err.response.data !== "undefined") {
          this.setState({errors: err.response.data.errors})
        }

      })
    }

  renderOption(option) {
      let due = this.getInvoiceDue(option)
    return <span>Invoice {option.series_name}{option.series_counter} Due: {due}</span>
  }

  getInvoiceDue(invoice) {

    if(typeof invoice !== "undefined" && invoice !== null) {
      let invoice_receipt_set = invoice.receipt_set
      if(invoice_receipt_set !== null && invoice_receipt_set.length > 0) {

          let paid = _.sum(_.map(invoice_receipt_set, ir => {
                  return parseFloat(ir.amount)
          }))

          return parseFloat(parseFloat(invoice.total) - paid).toFixed(2)
      }
      else {
        return parseFloat(invoice.total).toFixed(2)
      }
    }
    else {
      return 0
    }
  }



  render() {

    let receipt = this.state.receipt

    let invoiceOptions = this.state.invoiceOptions

    let submitButton = <button className="btn btn-success" onClick={this.submit}>Save</button>

    if(this.state.submitting) {
      submitButton = <button className="btn btn-success" disabled>Saving..</button>
    }

    let client = <ClientElement retn={receipt} onAddCallback={this.handleClientChange} />

    let amountError
    if(typeof this.state.errors !== "undefined") {

       let errors = this.state.errors
       if(typeof errors.amount !== "undefined") {
         amountError = <p className="text-danger">{errors.amount[0]}</p>
       }

    }

    let calculationMsg
    if(this.state.loadingInvoices) {
      calculationMsg = <span className="text-muted">Calculating due amount..</span>
    }
    else {
      calculationMsg = <span className="text-muted">Total Invoices: {this.state.client_total_invoices}, Total Receipts: {this.state.client_total_receipts}, Net Due Amount: {this.state.client_total_due}</span>
    }


    let form = <div className="form-horizontal">
          <div className="form-group">
            <div className="col-sm-2">
            Client
            </div>
            <div className="col-sm-10">
            {client}
            {calculationMsg}
            </div>

          </div>


          <div className="form-group">
            <div className="col-sm-2">
            Client Invoice
            </div>
            <div className="col-sm-10">
            <Select multi={false} onChange={this.handleInvoiceChange} valueRenderer={this.renderOption} openOnFocus={true}
            options={invoiceOptions} optionRenderer={this.renderOption} value={receipt.invoice} />
            </div>

          </div>


          <div className="form-group">
          <div className="col-sm-2">
          Amount (&#8377;)
          </div>
          <div className="col-sm-10">
          <input  type="text" name="amount" value={receipt.amount} onChange={this.handleInputChange} className="form-control input-sm" required />
          {amountError}
          </div>
          </div>

          <div className="form-group">
          <div className="col-sm-2">
          Date

          </div>

          <div className="col-sm-10">
          <CI2 applyDate={this.handleDateChange} date={receipt.date} />
          </div>
          </div>

          <div className="form-group">

          <div className="col-sm-2">
          Payment Mode
          </div>
            <div className="col-sm-10">
            <select name="mode" value={receipt.mode} className="form-control input-sm" onChange={this.handleInputChange}>
              <option value="cash" >CASH</option>
              <option value="card">CARD</option>
              <option value="cheque">CHEQUE</option>
              <option value="banktransfer">BANK TRANSFER</option>
              <option value="others">Others</option>
            </select>
            </div>
          </div>




          <div className="form-group">
          <div className="col-sm-2">
          Reference

          </div>

          <div className="col-sm-10">

          <input  type="text" name="reference" value={receipt.reference} onChange={this.handleInputChange} className="form-control input-sm" />
          </div>
          </div>


          <div className="form-group">
          <div className="col-sm-2">
          Notes
          </div>
           <div className="col-sm-10">
          <textarea name="notes" className="form-control input-sm" value={receipt.notes} onChange={this.handleInputChange}></textarea>
           </div>
          </div>

      </div>



      let pageHeader
      let deleteRetnBtn
      if(!this.state.loading) {

        if(this.state.mode === "edit") {
          pageHeader = <h3>{"Edit Receipt  #" + receipt.serial}</h3>
          deleteRetnBtn = <button className="btn btn-sm btn-danger" onClick={this.deleteReceipt}>Delete Receipt</button>
        }
        else {
          pageHeader =  <h3>Add Receipt</h3>
        }

        return <div className="container-fluid">
        <section className="medium">
              {pageHeader}
              <ul className="list-inline">
                <li className="pull-right">{deleteRetnBtn}</li>
              </ul>
        </section>
                  <div className="row">
                  <div className="col-md-6">
                  {form}
                  <div className="form-action-group text-right">
                  {submitButton}
                  </div>
                  </div>
                  </div>


    </div>
      }
      else {
        return <div>
            <Loader />
        </div>
      }


  }
}



// WEBPACK FOOTER //
// ./src/components/receipt/addreceipt.js